import { propAccessor, getTodayDate, stringToDate } from '@hc-frontend/utils'
import isEpicPlan from 'utils/pivot/plan/isEpicPlan'

const onlyDate = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate())

const daysDiff = (dateFrom: Date, dateTo: Date) =>
  Math.floor((dateTo.getTime() - dateFrom.getTime()) / (1000 * 60 * 60 * 24))

export default function requiresAgreement(state: Pivot.State): boolean {
  const plan = propAccessor(state, ['plans', state.planId]) as Plan
  const startDate = state.sDate && stringToDate(state.sDate)

  if (!plan || !isEpicPlan(plan) || !startDate) {
    return false
  }

  const todayOnlyDate = onlyDate(getTodayDate())
  const startDateOnlyDate = onlyDate(startDate)

  const appliesAgreement = daysDiff(todayOnlyDate, startDateOnlyDate) > 1
  if (!appliesAgreement) {
    return false
  }

  const agreementKey = `${state.planId}-${state.sDate}`
  return agreementKey !== propAccessor(state, 'hcStorage.delayedEffectiveDateAgreement')
}
